import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-[328px] rounded bg-gray-20 px-4 pb-8 pt-6 text-center" }

import BenefitItems, { BenefitItem } from "@/components/BenefitItems.vue";
import BottomLoginRegisterToggle from "@/components/BottomLoginRegisterToggle.vue";
import BaseFootnote from "@/components/BaseFootnote.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomContentModal',
  props: {
    items: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BottomLoginRegisterToggle, { class: "mb-6" }),
      (_ctx.items.length)
        ? (_openBlock(), _createBlock(BenefitItems, {
            key: 0,
            class: "text-left",
            items: _ctx.items
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(BaseFootnote)
  ], 64))
}
}

})